import { render } from "./account-editor.vue?vue&type=template&id=8ce64498&scoped=true"
import script from "./account-editor.vue?vue&type=script&lang=ts"
export * from "./account-editor.vue?vue&type=script&lang=ts"

import "./account-editor.vue?vue&type=style&index=0&id=8ce64498&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ce64498"

export default script